import config from '../../../../config/config';
import { Configuration, PeopleApi } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const peopleApi = new PeopleApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
